import DataTable from 'datatables.net-bs5';
import 'datatables.net-responsive';
import 'datatables.net-rowreorder';
import 'datatables.net-select';
import * as jQuery from 'jquery';
import { moment } from './app/utils/date';
import './vendor/clndr.js';

window['jQuery'] = window['$'] = jQuery;
window['moment'] = moment;

jQuery.extend(true, DataTable.ext.classes, {
  layout: {
    row: 'row justify-content-between',
  },
});

export { DataTable, jQuery };
